import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";

import {useSemanticSearchAbTest} from "../../ab_testing/hooks/use_semantic_search_ab_test";
import {useBoundingClientRect} from "../../hooks/use_bounding_client_rect";
import {HomepageHeaderContent} from "./HomepageHeaderContent";
import {HomepageSearch} from "./HomepageSearch";
import {HomePageSemanticSearchEntry} from "./HomePageSemanticSearchEntry";

const headerXl = require("../images/header_xl.png");
const headerLg = require("../images/header_lg.png");
const headerMd = require("../images/header_md.png");
const headerSm = require("../images/header_sm.png");
const headerXs = require("../images/header_xs.png");

export const HomepageHeader = () => {
    const {boundingClientRect: headerBoundingClientRect, elementRef: headerElementRef} = useBoundingClientRect<HTMLDivElement>();
    const {boundingClientRect: contentBoundingClientRect, elementRef: contentElementRef} = useBoundingClientRect<HTMLDivElement>();
    const {isSemanticSearchEnabled} = useSemanticSearchAbTest();

    // We need to  calculate search blend height - this will be viewport height minus header (dynamic) and navigation height (60px)
    const blendHeight = `${(headerBoundingClientRect?.height || 0) + 60}px`;
    // We need to calculate search blend top position - this will be bottom position of header content minus search input height with its margin (~68px)
    // Bear in mind this value is not update on window resize event - this is edge case
    const blendTopPosition = contentBoundingClientRect ? `${Math.floor(contentBoundingClientRect.bottom - 68)}px` : 0;

    return (
        <section className={homepageHeader} ref={headerElementRef}>
            <Picture
                sources={[
                    {minWidthPX: 0, src: headerXs, height: 360, width: 448},
                    {minWidthPX: 360, src: headerSm, height: 600, width: 448},
                    {minWidthPX: 600, src: headerMd, height: 588, width: 1366},
                    {minWidthPX: 1366, src: headerLg, height: 826, width: 1919},
                    {minWidthPX: 1919, src: headerXl, height: 1102, width: 2560}
                ]}
                alt="header"
                className={headerImageCss}
                fetchPriority="high"
            />

            <div ref={contentElementRef} className={homepageHeaderContentPositioner}>
                <HomepageHeaderContent />
                <HomepageSearch containerHeight={blendHeight} blendTopPosition={blendTopPosition} />

                {isSemanticSearchEnabled && <HomePageSemanticSearchEntry />}
            </div>
        </section>
    );
};

// INFO: `height` and `breakpoints` has connection with picture size
export const homepageHeader = css({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",

    "@media (min-width: 360px)": {
        minHeight: "290px"
    },
    "@media (min-width: 600px)": {
        minHeight: "220px"
    },
    md: {
        overflow: "visible",
        minHeight: "240px"
    },
    lg: {
        minHeight: "500px"
    },
    "@media (min-width: 1919px)": {
        minHeight: "730px"
    }
});

export const homepageHeaderContentPositioner = css({
    position: "absolute",
    left: 0,
    bottom: "3.6rem",
    width: "100%",
    zIndex: 10,

    md: {
        top: "50%",
        bottom: "unset",
        transform: "translateY(-50%)"
    }
});

export const headerImageCss = css({
    "& img": {
        maxWidth: "initial",
        sm: {
            maxWidth: "100%"
        }
    }
});
import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";

import {useSemanticSearchAbTest} from "../../ab_testing/hooks/use_semantic_search_ab_test";
import {useBoundingClientRect} from "../../hooks/use_bounding_client_rect";
import {HomepageHeaderContent} from "./HomepageHeaderContent";
import {HomepageSearch} from "./HomepageSearch";
import {HomePageSemanticSearchEntry} from "./HomePageSemanticSearchEntry";

const headerXl = require("../images/header_xl.png");
const headerLg = require("../images/header_lg.png");
const headerMd = require("../images/header_md.png");
const headerSm = require("../images/header_sm.png");
const headerXs = require("../images/header_xs.png");

export const HomepageHeader = () => {
    const {boundingClientRect: headerBoundingClientRect, elementRef: headerElementRef} = useBoundingClientRect<HTMLDivElement>();
    const {boundingClientRect: contentBoundingClientRect, elementRef: contentElementRef} = useBoundingClientRect<HTMLDivElement>();
    const {isSemanticSearchEnabled} = useSemanticSearchAbTest();

    // We need to  calculate search blend height - this will be viewport height minus header (dynamic) and navigation height (60px)
    const blendHeight = `${(headerBoundingClientRect?.height || 0) + 60}px`;
    // We need to calculate search blend top position - this will be bottom position of header content minus search input height with its margin (~68px)
    // Bear in mind this value is not update on window resize event - this is edge case
    const blendTopPosition = contentBoundingClientRect ? `${Math.floor(contentBoundingClientRect.bottom - 68)}px` : 0;

    return (
        <section className={homepageHeader} ref={headerElementRef}>
            <Picture
                sources={[
                    {minWidthPX: 0, src: headerXs, height: 360, width: 448},
                    {minWidthPX: 360, src: headerSm, height: 600, width: 448},
                    {minWidthPX: 600, src: headerMd, height: 588, width: 1366},
                    {minWidthPX: 1366, src: headerLg, height: 826, width: 1919},
                    {minWidthPX: 1919, src: headerXl, height: 1102, width: 2560}
                ]}
                alt="header"
                className={headerImageCss}
                fetchPriority="high"
            />

            <div ref={contentElementRef} className={homepageHeaderContentPositioner}>
                <HomepageHeaderContent />
                <HomepageSearch containerHeight={blendHeight} blendTopPosition={blendTopPosition} />

                {isSemanticSearchEnabled && <HomePageSemanticSearchEntry />}
            </div>
        </section>
    );
};

// INFO: `height` and `breakpoints` has connection with picture size
export const homepageHeader = css({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",

    "@media (min-width: 360px)": {
        minHeight: "290px"
    },
    "@media (min-width: 600px)": {
        minHeight: "220px"
    },
    md: {
        overflow: "visible",
        minHeight: "240px"
    },
    lg: {
        minHeight: "500px"
    },
    "@media (min-width: 1919px)": {
        minHeight: "730px"
    }
});

export const homepageHeaderContentPositioner = css({
    position: "absolute",
    left: 0,
    bottom: "3.6rem",
    width: "100%",
    zIndex: 10,

    md: {
        top: "50%",
        bottom: "unset",
        transform: "translateY(-50%)"
    }
});

export const headerImageCss = css({
    "& img": {
        maxWidth: "initial",
        sm: {
            maxWidth: "100%"
        }
    }
});
